import { render, staticRenderFns } from "./barChartDialog.vue?vue&type=template&id=0a2d885a&scoped=true"
import script from "./barChartDialog.vue?vue&type=script&lang=js"
export * from "./barChartDialog.vue?vue&type=script&lang=js"
import style0 from "./barChartDialog.vue?vue&type=style&index=0&id=0a2d885a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2d885a",
  null
  
)

export default component.exports